/**
 * Hook to get current user information
 *
 * Provides access to the currently authenticated user's name and email
 * without directly exposing authentication implementation details.
 */

import { useKeycloak } from '@lib/keycloak'

export interface CurrentUser {
  name: string
  email: string
}

/**
 * Get the current authenticated user's information
 *
 * @returns Current user with name and email, or null if not authenticated
 */
export const useCurrentUser = (): CurrentUser | null => {
  const { keycloak } = useKeycloak()

  if (!keycloak?.tokenParsed) {
    return null
  }

  const name = (keycloak.tokenParsed.name ?? keycloak.tokenParsed.preferred_username ??
    [keycloak.tokenParsed.given_name, keycloak.tokenParsed.family_name].filter(Boolean).join(' ')
  ) as string | undefined
  const email = keycloak.tokenParsed.email as string | undefined

  if (!name || !email) {
    return null
  }

  return {
    name,
    email,
  }
}
